import {
  AttachmentFileInterface,
  UnsavedAttachmentFileInterface,
} from 'shared/components/dashboard-mail-editor/types/email-interface'

export const isAttachmentInterface = (
  attachment: AttachmentFileInterface | UnsavedAttachmentFileInterface,
): attachment is AttachmentFileInterface => attachment.hasOwnProperty('id')
